import script from "./audio-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./audio-message.vue?vue&type=script&lang=ts&setup=true"

import "./audio-message.vue?vue&type=style&index=0&id=2c5182c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5182c8"]])

export default __exports__